<template>
  <div class="manage-event-detail-container">
    <div :class="{'isLoading': getIsLoading, 'noDisplay': !getIsLoading}" class="overlay">
      <div class="spinner-align">
        <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
      </div>
    </div>

    <div v-if="!getIsLoading" class="event-detail-wrapper margin-side modal-padding">
      <div class="event-detail-header row">
        <div class="col-md-6 noPaddingLeft">
          <span class="event-details">{{event.eventName}}</span>
        </div>

        <div class="col-md-6 noPaddingRight align-right-item">
          <div class="modal-close-img" @click="back()">
            <div class="icon-close"></div>
          </div>
        </div>
      </div>

      <!-- Event Information -->
      <!-- Title -->
      <div class="event-detail-body row margin-top-24px">
        <div class="col-md-6 event-information noPaddingLeft">
          Event information
        </div>
        <div class="col-md-6 event-information noPaddingRight align-right-item">
          <div class="staffing-edit-btn">
            <button v-if="editing" class="ap-btn secondary" @click="onSave">Save</button>
            <button v-else class="ap-btn secondary" @click="onEdit">Edit</button>
          </div>
        </div>
      </div>

      <!-- Event Name, Date, Client, Planning Notes -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-3">
          <span class="event-title">Event Name</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.eventName"></textarea>
            <span v-else>{{event.eventName}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Date</span><br/>
          <div class="event-info">
            <date-picker v-if="editing" :value="event.prefDate" :format="'MMMM d, yyyy'"></date-picker>
            <span v-else>{{event.prefDate | dateFormatMMMM}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Client</span><br/>
          <div class="event-info">{{event.clientName}}</div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Custom Event Notes</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.customEventNote"></textarea>
            <span v-else>{{event.customEventNote}}</span>
          </div>
        </div>
      </div>

      <!-- Address, Time and Duration, Program, On Site Constructions -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-3">
          <span class="event-title">Address</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.fullAddress"></textarea>
            <span v-else>{{event.fullAddress}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Time and Duration</span><br/>
          <div class="event-info show-dropdown">
            <table>
              <tr>
                <td>Start: </td>
                <td>
                  <select v-if="editing" v-model="event.startTime">
                    <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
                  </select>
                  <span v-else>{{event.startTime}}</span>
                </td>
              </tr>
              <tr>
                <td>End: </td>
                <td>
                  <select v-if="editing" v-model="event.endTime">
                    <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
                  </select>
                  <span v-else>{{event.endTime}}</span>
                </td>
              </tr>
              <tr>
                <td>Duration: </td>
                <td>
                  <template v-if="editing">
                    <select v-model="event.duration">
                      <option v-for="n in 24" :value="n">{{n}}</option>
                    </select>
                  </template>
                  <span v-else>{{event.duration}}</span>
                  HR
                </td>
              </tr>
              <tr>
                <td>Time zone: </td>
                <td>
                  {{event.timeZone}}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Program</span><br/>
          <div class="event-info">{{event.eventName}}</div>
<!--          <div class="add-on-wrapper">-->
<!--              <div class="event-add-on">-->
<!--                <input type="checkbox" v-model="event.isOnlineScheduler" id="is-online-scheduler" @change="updateIsLiveEvent('ONLINE_SCHEDULER')"/>-->
<!--                <label for="is-online-scheduler">Toggle</label>-->
<!--              </div>-->
<!--              <div class="text" :class="{'online-text': event.isOnlineScheduler}">Online Scheduler</div>-->
<!--          </div>-->
        </div>
        <div class="col-md-3">
          <span class="event-title">On Site Instructions</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.onsiteInstruction"></textarea>
            <span v-else>{{event.onsiteInstruction}}</span>
          </div>
        </div>
      </div>

      <!-- Building/Suite, Aduro Arrival Time, On Site Contact, Parking Instructions -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-3">
          <span class="event-title">Building/Suite</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.building"></textarea>
            <span v-else>{{event.building}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">ADURO Arrival Time</span><br/>
          <div class="event-info">
            <select v-if="editing" v-model="event.aduroArrivalTime">
              <option v-for="time in listTime" :value="time.name">{{time.name}}</option>
            </select>
            <span v-else>{{event.aduroArrivalTime}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">On Site Contact</span><br/>
          <div class="event-info">{{event.contactName}}</div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Parking Instructions</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.parkingInformation"></textarea>
            <span v-else>{{event.parkingInformation}}</span>
          </div>
        </div>
      </div>

      <!-- Location, Participation, Add-ons, Live -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-3">
          <span class="event-title">Location</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.eventLocation"></textarea>
            <span v-else>{{event.eventLocation}}</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Participation</span><br/>
          <div class="event-info">
            <div class="oval oval-red"></div>
            <span>{{event.numParticipant}}/{{event.maxParticipant}} participants</span>
          </div>
        </div>
        <div class="col-md-3">
          <span class="event-title">Add-ons</span><br/>
          <div class="event-info">
            <div v-for="(item, index) in addOns" :key="index" class="add-on-wrapper">
              <div class="event-add-on mb-1">
                <input type="checkbox" :id="item.key" v-model="item.value" @change="checkboxToggle(item.key, item.value)"/>
                <label :for="item.key">Toggle</label>
              </div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="add-on-wrapper">
            <div class="event-add-on">
              <input type="checkbox" v-model="event.isLive" id="is-live" @change="updateIsLiveEvent('LIVE')"/>
              <label for="is-live">Toggle</label>
            </div>
            <div class="text" :class="{'online-text': event.isLive}">Live</div>
          </div>
        </div>
      </div>

      <!-- On Site Contacts -->
      <div class="event-detail-body row">
        <div class="col-md-12 liner"></div>
      </div>

      <!-- Title -->
      <div class="event-detail-body row">
        <div class="col-md-6 event-information noPaddingLeft">
          On Site Contacts
        </div>
      </div>

      <!-- Contact Info -->
      <div class="event-detail-body row" v-if="event.contactName">
        <div class="col-md-4 margin-top-16px">
          <div class="wrapper-text">
            <div class="event-info">{{event.contactName}}</div>
            <div class="event-info">{{event.email}}</div>
            <div class="event-info">{{event.phone}}</div>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="event-detail-body row">
        <div class="col-md-12 liner"></div>
      </div>

      <!-- Title -->
      <div class="event-detail-body row">
        <div class="col-md-6 event-information noPaddingLeft">
          <span>Email</span>
          <span class="view-history-text" @click="viewAllMailHistories">View History</span>
        </div>
        <div class="col-md-6 noPaddingRight noPaddingLeft align-right-item">
          <div class="staffing-edit-btn">
            <button class="ap-btn secondary"  @click="manageEmail">Email Client</button>
          </div>
        </div>
      </div>

      <!-- Email Info -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-12 email-text noPaddingLeft">
          Last Email Sent: {{event.emailReminderStatus | templateName}}
        </div>
      </div>

      <!-- Staff & Slot Management -->
      <div class="event-detail-body row">
        <div class="col-md-12 liner"></div>
      </div>

      <!-- Title -->
      <div class="event-detail-body row">
        <div class="col-md-9 event-information noPaddingLeft">
          Staff & Slot Management
        </div>
        <div class="col-md-3 noPaddingRight noPaddingLeft align-right-item">
          <div class="staffing-edit-btn">
            <button class="ap-btn secondary" @click="manageEventStaffingDetail">Manage</button>
          </div>
        </div>
      </div>

      <!-- Leads, Concierge, Screeners -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-12 noPaddingLeft">
          <div class="wrapper-text-number display-inline">
            <div class="oval oval-red"></div>
            <span class="number">{{event.numStaffLead}}/{{event.maxStaffLead}} Leads</span>
          </div>
          <div class="wrapper-text-number display-inline">
            <div class="oval oval-red margin-left-8px"></div>
            <span class="number">{{event.numStaffConcierge}}/{{event.maxStaffConcierge}} Concierge</span>
          </div>
          <div class="wrapper-text-number display-inline">
            <div class="oval oval-red margin-left-8px"></div>
            <span class="number">{{event.numStaffScreener}}/{{event.maxStaffScreener}} Screeners</span>
          </div>
        </div>
      </div>

      <!-- Shipping -->
      <div class="event-detail-body row">
        <div class="col-md-12 liner"></div>
      </div>

      <!-- Title -->
      <div class="event-detail-body row">
        <div class="col-md-6 event-information noPaddingLeft">
          Shipping
        </div>
        <div class="col-md-6 event-information noPaddingRight noPaddingLeft align-right-item">
          <div class="staffing-edit-btn">
            <button class="ap-btn secondary" @click="generatePackingSlipBtn()">Generate Packing Slip</button>
          </div>
        </div>
      </div>

      <!-- Address, Supplies Tracking, Packing Slip Tracking, Tracking Number -->
      <div class="event-detail-body row margin-top-16px">
        <div class="col-md-3">
          <span class="event-title">Address</span><br/>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.shippingAddress"></textarea>
            <span v-else>{{event.shippingAddress}}</span>
          </div>
        </div>

        <div class="col-md-3">
          <span class="event-title">Supplies Tracking</span>
          <div class="supplies-tracking-status margin-bottom-10px">
            <div class="oval" :class="shippingStatus !== '' ? 'oval-green' : 'oval-red'"></div>
            <span
              class="">{{trackingNumber !== '' ? (shippingStatus !== '' ? shippingStatus : 'Shipping info not entered') : 'Shipping info not entered'}}</span>
          </div>
        </div>

<!--        <div class="col-md-3">-->
<!--          <span class="event-title">Packing Slip Tracking</span>-->
<!--          <div class="supplies-tracking-status margin-bottom-10px">-->
<!--            <div class="oval" :class="shippingStatus !== '' ? 'oval-green' : 'oval-red'"></div>-->
<!--            <span-->
<!--              class="">{{trackingNumber !== '' ? (shippingStatus !== '' ? shippingStatus : 'Shipping info not entered') : 'Shipping info not entered'}}</span>-->
<!--          </div>-->
<!--        </div>-->

        <div class="col-md-3">
          <span class="event-title">Tracking Number</span>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.trackingNumber"></textarea>
            <span v-else>{{trackingNumber}}</span>
          </div>
        </div>

        <div class="col-md-3">
          <span class="event-title">Shipping Note</span>
          <div class="event-info">
            <textarea v-if="editing" v-model="event.shippingNote"></textarea>
            <span v-else>{{event.shippingNote}}</span>
          </div>
        </div>
      </div>

      <!-- Related Events -->
      <div class="event-detail-body row">
        <div class="col-md-12 liner"></div>
      </div>

      <!-- Title -->
      <div class="series-related-events-section">
        <div class="related-events-top event-detail-body row">
          <div class="col-md-6 event-information noPaddingLeft">
            Related Events
            <span>({{event.relatedEvents.length}})</span>
          </div>

          <div class="col-md-6 noPaddingRight noPaddingLeft align-right-item">
            <div class="staffing-edit-btn">
              <button v-if="event.relatedEvents.length == 0" class="btn-add-related ap-btn secondary" @click="manageRelatedEvent">Create Related Events</button>
              <button v-else class="btn-add-related ap-btn secondary" @click="manageRelatedEvent">Manage Related Events</button>
            </div>
          </div>
        </div>

        <!-- Related Events Info -->
        <div class="related-event-container event-detail-body row">
          <div v-for="reEvent in event.relatedEvents" class="col-md-3 margin-top-16px">
            <div class="related-event-item">
              <div class="event-name" @click="relatedEventItemClick(reEvent.id)">{{reEvent.eventName}}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import consts from '../../_consts';
  import {mapActions, mapMutations} from 'vuex';
  import VueSlider from 'vue-slider-component';
  import Icon from 'vue-awesome/components/Icon';
  import emailTemplateConsts from '@/store/constants/emailTemplateType';
  import DatePicker from 'vuejs-datepicker';
  import VueDropdown from 'vue-dropdowns';
  import VueSelect from 'vue-select';
  import _ from 'lodash';
  import Vue from 'vue';

  export default {
    name: 'event-detail-view',
    components: {
      VueSlider,
      Icon,
      DatePicker,
      VueDropdown,
      VueSelect
    },
    props: {},
    data () {
      return {
        editing: true,
        event: {
          relatedEvents: []
        },
        shippingStatus: '',
        trackingNumber: '',
        program: '',
        emailTemplateConsts: emailTemplateConsts,
        addOnsServices: '',
        listTime: consts.listTime,
        startTime: {
          hour: '',
          minute: '',
          period: 'AM'
        },
        endTime: {
          hour: '',
          minute: '',
          period: 'AM'
        },
        aduroArrivalTime: {
          hour: '',
          minute: '',
          period: 'AM'
        },
        addOns: [
          {
            key: 'venipuncture',
            text: 'Venipuncture',
            value: false
          },
          {
            key: 'cotinine',
            text: 'Cotinine',
            value: false
          },
          {
            key: 'wbaStation',
            text: 'WBA Station',
            value: false
          },
          {
            key: 'fluShots',
            text: 'Flu Shots',
            value: false
          },
          {
            key: 'paperScheduler',
            text: 'Paper Scheduler',
            value: false
          },
          {
            key: 'smallSiteModel',
            text: 'Small Site Model',
            value: false
          },
          {
            key: 'smallSiteConcierge',
            text: 'Small Site Concierge',
            value: false
          },
          {
            key: 'tobaccoSelfAttestation',
            text: 'Tobacco Self Attestation',
            value: false
          }
        ]
      }
    },
    created () {
      // this.$store.dispatch('ACTION_GET_ALL_USERS');
    },
    methods: {
      back () {
        let isFromStaff = localStorage.getItem('isFromStaff');
        let isFromClientDashboardView = localStorage.getItem('isFromClientDashboardView');
        if (isFromStaff === true || isFromStaff === 'true') {
          localStorage.setItem('isFromStaff', false);
          this.$router.push({name: 'StaffingSection', params: {detail: this.getStaffDetail}});
        } else if (isFromClientDashboardView === true || isFromClientDashboardView === 'true') {
          localStorage.setItem('isFromClientDashboardView', false);
          this.$router.push({name: 'ManagerDashboardView'});
          this.$bus.$emit('resetGetData', this.eventId);
        } else {
          if (this.historyRouter) {
            this.$router.push({name: this.historyRouter, params: {eventId: this.eventId}});
            return;
          }

          this.$router.push({name: 'ManageApprovedDashboard', params: {eventId: this.eventId, textSearch: localStorage.getItem(consts.LOCAL_STORE.searchEventString), filter: localStorage.getItem(consts.LOCAL_STORE.filterEventString), sort: localStorage.getItem(consts.LOCAL_STORE.sortEventString), dateSliderValue: localStorage.getItem(consts.LOCAL_STORE.dateRangeEvent)}});
        }
      },
      onSave () {
        this.editing = false;
        this.updateEventAction(this.event);
      },
      onEdit () {
        this.editing = true;
      },
      updateIsLiveEvent (type) {
        let isCheck = false;
        switch (type) {
          case 'LIVE':
            isCheck = this.event.isLive;
            break;
          case 'ONLINE_SCHEDULER':
            isCheck = this.event.isOnlineScheduler;
            break;
          default:
            isCheck = false;
        }
        this.actionUpdateIsLiveEvent({
          eventId: this.event.id,
          isCheck: isCheck || false,
          onlineType: type
        }).then((response) => {
          if (response.message) {
            this.$toastr('error', response.message, '');
          } else {
            this.$toastr('success', 'Update event successful!', '');
          }
        });
      },
      getTrackingStatus () {
        if (!this.event.id || !this.trackingNumber) {
          return;
        }
        this.actionGetTrackingStatus({eventId: this.event.id, trackingNumber: this.trackingNumber}).then(response => {
          this.shippingStatus = (response && response.shippingStatus && response.shippingStatus.trackingStatusDescription) || '';
        });
      },
      viewAllMailHistories () {
        this.$router.push({name: 'EmailHistoriesManagement', params: {eventId: this.event.id}});
      },
      manageRelatedEvent () {
        let data = {
          eventId: this.event.id,
          relatedEvents: this.event.relatedEvents,
          routerName: this.$route.name
        };
        this.$router.push({name: 'ManageRelatedEvent', params: data, query: data.eventId});
      },
      manageEmail () {
        let eventId = this.event.id;
        this.setIsLoading(true); // set loading = true
        this.$router.push({
          name: 'ManageEmail',
          params: {
            eventId: eventId,
            isManageDetails: true
          }
        });
      },
      manageEventStaffingDetail () {
        let data = {
          eventId: this.event.id,
          routerName: this.$route.name
        };
        this.$router.push({name: 'EventStaffingDetail', params: data});
      },
      generatePackingSlipBtn () {
        this.generatePackingSlip(this.event.id);
      },
      relatedEventItemClick (eventId) {
        let url = window.location.origin + '/event/' + eventId;
        window.open(url, '_blank');
      },
      minutes () {
        let range = _.range(0, 60);
        return _.map(range, value => {
          return (value > 9 ? '' : '0') + value;
        });
      },
      formatTime (hour, minute, period) {
        return hour + ':' + minute + ' ' + period;
      },
      parseTime (time) {
        if (!time) {
          return { hour: '', minute: '', period: 'AM' }
        }

        let period = time.split(' ')[1];
        let fullTime = time.split(' ')[0].split(':');

        return {
          hour: fullTime[0],
          minute: fullTime[1],
          period: period
        }
      },
      checkboxToggle (key, value) {
        let obj = {
          clientId: this.event.clientId,
          eventId: this.event.id,
          key: key,
          isAdd: value
        };

        let addOn = _.find(this.addOns, {'key': key});
        this.updateAddOn(obj).then(() => {
          Vue.prototype.$toastr('success', 'Update event successful');
        }).catch(() => {
          addOn.value = !value;
        });
      },
      ...mapActions({
        getEventById: 'ACTION_GET_EVENT_BY_ID',
        actionGetTrackingStatus: 'ACTION_GET_TRACKING_STATUS',
        actionUpdateIsLiveEvent: 'ACTION_UPDATE_IS_LIVE_EVENT',
        generatePackingSlip: 'ACTION_GENERATE_PACKING_SLIP',
        updateAddOn: 'ACTION_UPDATE_EVENT_ADD_ON',
        updateEventAction: 'ACTION_UPDATE_EVENT'
      }),
      ...mapMutations({
        setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {

    },
    mounted () {
      this.historyRouter = this.$route.params.routerName;
      let eventId = this.$route.params.eventId;
      this.eventId = eventId;
      // get event
      // reset shipping status
      this.trackingNumber = null;
      this.shippingStatus = '';
      this.getEventById(eventId).then(response => {
        let event = response.event;
        this.startTime = this.parseTime(event.startTime);
        this.endTime = this.parseTime(event.endTime);
        this.aduroArrivalTime = this.parseTime(event.aduroArrivalTime);

        if (response.message === null) {
          this.event = event;

          // get add ons
          this.addOns.forEach(addOn => {
            if (this.event.addOns.includes(addOn.key)) {
              addOn.value = true;
            }
          });

          // get shipping status
          if (this.event && this.event.trackingNumber) {
            this.trackingNumber = this.event.trackingNumber;
            this.actionGetTrackingStatus({eventId: eventId, trackingNumber: this.event.trackingNumber}).then(response => {
              this.shippingStatus = (response && response.shippingStatus && response.shippingStatus.trackingStatusDescription) || '';
            });
          }
        }
      });
    }
  };
</script>

<style lang="less" scoped>
@import '../../styles/variables.less';

.manage-event-detail-container {
  background: @white;

  .modal-padding {
    padding: 24px 40px 20px 40px;
  }

  .icon-back {
    margin: 1.5px 1.5px;
    width: 27px;
    height: 27px;
    color: @grey-3;
    background-color: @grey-3;
    -webkit-mask: url('../../../static/img/backward-line.svg') no-repeat center;
    mask: url('../../../static/img/backward-line.svg') no-repeat center;
    background: url('../../../static/img/backward-line-grey.svg');
  }
  .icon-align {
    margin-bottom: 10px;
    padding-left: 8px;
    margin-top: 24px;

    &:hover{
      cursor: pointer;
    }
  }

  .series-related-events-section{
    .related-events-top{
      justify-content: space-between;
      margin-top: -10px;

      .related-events-top-left{
        display: flex;
        align-items: center;

        .related-events-title{
          color: @black-2;
          font-size: 16px;
          font-weight: bold;
        }

        .related-event-count{
          color: @grey-9;
          font-size: 12px;
          margin-left: 8px;
          font-weight: normal;
          text-transform: uppercase;
        }
      }

      .button-containers{
        margin-left: 12px;

        .btn-left{
          padding: 6px 24px;
          font-size: 16px;
          font-weight: 600;
        }
        .btn-right{
          height: 24px;
          padding: 0 12px;
          font-size: 12px;
        }
      }
    }

    .related-event-container{
      .related-event-item{
        height: 32px;
        padding: 8px;
        border: 1px solid @grey-4;
        border-radius: 4px;
        margin-bottom: 16px;

        .event-name{
          color: @black-3;
          font-family: @font-family-main;
          font-size: 12px;
          line-height: 16px;
        }

        &:hover{
          cursor: pointer;
          background-color: @grey-3;
        }
      }
    }

    .btn-add-related-container{
      margin-top: 8px;

      .btn-add-related{
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
  .event-detail-header {
    .wrapper-participant {
      display: flex;
      justify-items: flex-end;
      flex-direction: column;
      text-align: right;
    }
    .wrapper-multi-select {
      .multi-select-text{
        padding: 0;
        width: 275px;
      }
      .multiselect{
        min-height: 38px;
      }
      .multiselect__tags{
        border: none;
        min-height: 38px;
      }
      .multiselect__content-wrapper{
        // background-color: none;
        // background: none;
        .multiselect__element:last-child{
          border-bottom: none;
        }
      }
    }
    .event-details {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 32px;
    }
    .client-name {
      color: @light-blue;
      font-family: @font-family-main;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0.17px;
      line-height: 28px;
    }
    .event-name {
      color: @grey-8;
      font-family: @font-family-main;
      font-size: 16px;
      line-height: 24px;
      text-align: right;
      float: right;
      clear: both;
    }
    .map {
      height: 200px;
      width: 100%;
      border: 1px solid @grey-8;
    }
  }
  .modal-close-img {
    display: flex;
    justify-content: flex-end;

    &:hover{
      cursor: pointer;
    }
    .icon-close {
      margin: 1.5px 1.5px;
      width: 16px;
      height: 16px;
      color: @black-3;
      background-color: @black-3;
      -webkit-mask: url('../../../static/img/action-close-black.svg') no-repeat center;
      mask: url('../../../static/img/action-close-black.svg') no-repeat center;
      background: url('../../../static/img/action-close-black.svg');
    }
  }
  .event-detail-body {
    align-items: flex-start;

    .email-text {
      color: #1D1D1D;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }

    .col-md-3:nth-child(4n + 1) {
      padding-left: 0;
    }

    .col-md-3:nth-child(4n) {
      padding-right: 0;
    }

    .col-md-4:nth-child(3n + 1) {
      padding-left: 0;
    }

    .col-md-4:nth-child(3n) {
      padding-right: 0;
    }

    .view-history-text {
      color: @blue-2;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.1px;
      line-height: 24px;
      cursor: pointer;
      margin-left: 16px;
    }
    .staff-header {
      color: @black-2;
      font-size: 16px;
      font-weight: bold;
    }
    .staffing-edit-btn {
      .ap-btn{
        padding: 4px 24px;
        text-transform: none;
        border: 1px solid #B9B9B9;
        font-size: 16px;

        &.secondary {
          color: @blue-2;
          &:hover {
            background-color: @blue-2;
            color: @white;
          }
        }
      }
    }

    textarea {
      width: 100%;
    }

    .text {
      //width: 118px;
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;

      &.online-text {
        color: @blue-2;
      }
    }

    .number {
      width: 177px;
      color: @black-2;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }

    .group-btn-manage-detail{
      display: flex;
      justify-content: flex-end;

      .icon-email-wrapper{
        width: 32px;
        height: 32px;
        background-color: @light-blue;
        padding: 4px;
        border-radius: 4px;
        &:hover{
          cursor: pointer;
        }

        .icon-email{
          width: 24px;
          height: 24px;
          background: url('../../../static/img/24px-mail-white.svg');
        }
      }

      .ap-btn{
        padding: 6px 17px;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
      }

      .btn-left{
        margin-right: 8px;
      }

    }

    .manage-detail {
      height: 32px;
      width: 184px;
      border: 1px solid @light-blue;
      border-radius: 4px;
      float: right;
      .manage-text {
        color: @light-blue;
        font-family: @font-family-main;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        line-height: 20px;
        cursor: pointer;
        position: relative;
        top: 50%;
        left: 50%;
        float: left;
        transform: translate(-50%, -50%);
      }
    }
    .btn-request-change{
      min-width: 215px;
    }
    .request-change {
      height: 32px;
      width: 184px;
      background-color: #AAA7A4;
      border-radius: 4px;
      .request-text {
        color: @white;
        font-family: @font-family-main;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.1px;
        line-height: 20px;
        cursor: pointer;
        position: relative;
        top: 50%;
        left: 50%;
        float: left;
        transform: translate(-50%, -50%);
        text-transform: uppercase;
      }
    }
    .wrapper-text-number {
      margin-right: 24px;
    }

    .liner {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid @grey-4;
      margin-top: 24px;
      margin-bottom: 24px;
    }
    .liner-for-staff {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid @grey-4;
      margin-top: 22px;
      margin-bottom: 18px;
    }
    .event-information {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
    }
    .event-title {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      text-transform: none;
      margin-top: 14px;
    }
    .event-info {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
      margin-top: 4px;
    }
    .shipping-notes {
      color: @grey-8;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }
    .input-shipping-notes {
      height: 78px;
      width: 402px;
      border: 1px solid @grey-3;
      border-radius: 4px;
    }
    .on-site-instruction {
      height: 63px;
      width: 184px;
      border: 1px solid @grey-3;
      border-radius: 4px;
      color: #1D1D1D;
      font-family: 'Open Sans', sans-serif;
      font-size: 12px;
      line-height: 16px;
    }
    .tracking-number {
      height: 31px;
      width: 402px;
      border-radius: 4px;
      border: 1px solid @grey-3;
      text-transform: uppercase;
      color: #424242;
      font-family: @font-family-main;
      font-size: 12px;
    }
    .supplies-tracking-status {
      color: @black-2;
      font-family: @font-family-main;
      font-size: 12px;
      line-height: 16px;
    }
    .add-on-wrapper {
      float: left;
      //height: 33px;
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 4px;
      .title {
        color: #626262;
        font-family: @font-family-main;
        font-size: 12px;
        line-height: 16px;
      }
      .event-add-on {
        overflow: hidden;
        margin-right: 8px;

        .add-on-item-wrapper {
          // margin-left: -30px;
          // height: 110px;
        }
        .title {
          margin-top: 20px;
          // color: #fff;
          // background-color: #0080A5;
          .icon-add {
            color: #fff;
            background-color: #00A4D6;
            border: 3px;
            border-radius: 20px;
            width: 16px;
            height: 16px;
            margin-left: 15px;
          }
          .text {
            margin-left: 10px;
            color: #00A4D6;
            font-family: "Open Sans", sans-serif;
            font-size: 12px;
            text-transform: capitalize;
          }
        }
        .add-on-item {
          width: 210px;
          position: relative;
          margin-left: 0;
          margin-top: 15px;
          display: inline-block;
          .text {
            position: absolute;
            left: 45px;
          }
        }
        input[type=checkbox] {
          //height: 0;
          width: 0;
          visibility: hidden;
        }

        label {
          float: left;
          cursor: pointer;
          text-indent: -9999px;
          width: 32px;
          height: 16px;
          background: #fff;
          border-radius: 24px;
          position: relative;
          top: 1px;
          left: 0px;
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 0;
        }

        label:after {
          content: '';
          position: absolute;
          top: -0.7px;
          left: -0.7px;
          width: 14px;
          height: 14px;
          background: #fff;
          border-radius: 24px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        input:checked + label {
          background: @blue-2;
          border: 2px solid @blue-2;
          // border: none;
        }

        input:checked + label:after {
          // top: -0.5px;
          left: calc(100% + 4px);
          transform: translateX(-100%);
          //box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
        }

        label:active:after {
          width: 15px;
        }
      }
    }

    .wrapper-text {
      padding: 8px;
      border: 1px solid @grey-3;
      border-radius: 4px;
    }
  }
}

.oval {
  height: 8px;
  width: 8px;
  display: inline-block;
  border-radius: 3px;
  margin-left: 0;
  margin-right: 8px;

  &.oval-red {
    background-color: #E93000;
  }
  &.oval-green {
    background-color: #68B814;
  }
  &.oval-orange {
    background-color: #FFA71B;
  }
  &.ovalSilver {
    background-color: #D8D8D8;
  }
  &.margin-left-8px {
    margin-left: 8px;
  }
}

.isLoading {
  display: block;
  text-align: center;
  color: #606060;
  height: 100%;
}

.noDisplay {
  display: none;
}

.display-inline {
  display: inline;
}

.padding-top-5px {
  padding-top: 5px;
}

.overlay {
  position: relative;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  cursor: pointer;
}

.spinner-align {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.align-right-item {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// ManageEventDetail.vue?454ae0a0